import Table from './Table';
import Search from './Search';
import Time from './Time';
import { useContext, useState, useEffect } from 'react';
import { TableContext } from '../context';
import Loader from './Loader';
import SubscribeDialog from './SubscribeDialog';
import CiInfoDrawer from "./CiInfoDrawer";
import ChangeDetailsDrawer from "./ChangeDetailsDrawer";
import DeploymentDetailsDrawer from "./DeploymentDetailsDrawer";
import VendorChangeDetailsDrawer from "./VendorChangeDetailsDrawer";
import { McTabBar } from "@maersk-global/mds-react-wrapper/components-core/mc-tab-bar";
import { McTab } from "@maersk-global/mds-react-wrapper/components-core/mc-tab";
import VendorChangeTable from './VendorChangeTable';
import CICDTable from './CICDTable';

function Changes() {
  const { 
    graphData, 
    tableData, 
    setTableData, 
    cicdTableData,
    setCICDTableData,
    loading, 
    setLoading, 
    tokenFetched, 
    setTokenFetched, 
    getTableData, 
    search, 
    setSearch,
    selectedTime,
    activeHomeTab,
    setActiveHomeTab,
    searchType,
    applyUserPreferenceOnPageLoad,
  } = useContext(TableContext);

  const [isdrawerOpen, setisdrawerOpen] = useState(false);
  const [drawerCi, setDrawerCi] = useState("");
  const [drawerCiCategory, setDrawerCiCategory] = useState("");
  const [drawerType, setDrawerType] = useState("ci_info");
  const [drawerChange, setDrawerChange] = useState("");

  const tabLabels = ["SNOW Changes", "CI/CD Changes", "Vendor Changes"];

  // Apply user preference with current time as reference when Changes page loads
  useEffect(() => {
    if (tokenFetched) {
      applyUserPreferenceOnPageLoad();
    }
  }, []);

  useEffect(() => {
    if (tokenFetched) {
      getTableData(activeHomeTab);
    }
  }, [tokenFetched, selectedTime, search, searchType]);// called when tokenFetched or selected time changes

  const handleTabChange = (e) => {
    setLoading(true);
    console.log("Tab change event:", e);
    // Get the tab index from e.detail
    const tabIndex = e.detail;
    // Map the index to the corresponding label
    const newTabLabel = tabLabels[tabIndex];
    console.log("Tab changed to:", newTabLabel);
    setActiveHomeTab(newTabLabel);
    getTableData(newTabLabel);
  };

  const getMainTabIndex = () => {
    if (activeHomeTab === "SNOW Changes") return 0;
    if (activeHomeTab === "CI/CD Changes") return 1;
    if(activeHomeTab === "Vendor Changes") return 2;
    return 0; // default to first tab
  };

  return (
    <>
      {/* {loading && <Loader />} */}
      {isdrawerOpen && (
        drawerType === "ci_info" ? (
          <CiInfoDrawer
            isdrawerOpen={isdrawerOpen}
            setisdrawerOpen={setisdrawerOpen}
            drawerCi={drawerCi}
            drawerCiCategory={drawerCiCategory}
          />
        ) : drawerType === "change_details" ? (
            <ChangeDetailsDrawer
              isdrawerOpen={isdrawerOpen}
              setisdrawerOpen={setisdrawerOpen}
              drawerCi={drawerCi}
              drawerCiCategory={drawerCiCategory}
              drawerChange={drawerChange}
            />
          ) : drawerType === "vendor_change_details" ? (
            <VendorChangeDetailsDrawer
              isdrawerOpen={isdrawerOpen}
              setisdrawerOpen={setisdrawerOpen}
              drawerChange={drawerChange}
            />
          ) : (
            <DeploymentDetailsDrawer
              isdrawerOpen={isdrawerOpen}
              setisdrawerOpen={setisdrawerOpen}
              drawerCi={drawerCi}
              drawerCiCategory={drawerCiCategory}
              drawerChange={drawerChange}
            />
          )
      )}
      <div className='home'>
        {/* <h2 style={{padding: '1.2rem 2.5rem 0rem', fontWeight: '500', fontSize: '1.5rem'}}>Search For Application</h2> */}
        <div className='search' style={{display: 'flex', justifyContent: 'space-between', margin: '30px 40px 45px'}}>
            <Search />
            <Time />
        </div>
        <div style={{ margin: "0 40px" }}>
          <McTabBar tabchange={handleTabChange} currentindex={getMainTabIndex()}>
            <McTab slot="tab" label="SNOW Changes" active={activeHomeTab === "SNOW Changes"}></McTab>
            <div slot="panel">
              {
                <Table
                  Header1="Change Number"
                  Header2="Configuration Item"
                  Header3="Risk"
                  Header4="Short Description"
                  Header5="Planned Start Date"
                  Header6="Planned End Date"
                  Header7="State"
                  Header8="Type"
                  Header9="Assignment Group"
                  Header10="Requested By"
                  Header11="Close Code"
                  // Header12="Category"
                  setisdrawerOpen={setisdrawerOpen}
                  setDrawerCi={setDrawerCi}
                  setDrawerCiCategory={setDrawerCiCategory}
                  setDrawerType={setDrawerType}
                  setDrawerChange={setDrawerChange}
                  isLoading={loading}
                />}
            </div>
            <McTab slot="tab" label="CI/CD Changes" active={activeHomeTab === "CI/CD Changes"}></McTab>
            <div slot="panel">
              {
                <CICDTable
                  Header1="Change Number"
                  Header2="Application ID"
                  Header3="Application Name"
                  Header4="Repository Name"
                  Header5="Completed At"
                  Header6="Environment"
                  Header7="Deployment Link"
                  Header8="State"
                  setisdrawerOpen={setisdrawerOpen}
                  setDrawerCi={setDrawerCi}
                  setDrawerCiCategory={setDrawerCiCategory}
                  setDrawerType={setDrawerType}
                  setDrawerChange={setDrawerChange}
                  isLoading={loading}
                />
              }
            </div>
            <McTab slot="tab" label="Vendor Changes" active={activeHomeTab === "Vendor Changes"}></McTab>
            <div slot='panel'>
              <VendorChangeTable
                Header1="Change ID"
                Header2="Change Title"
                Header3="Category"
                Header4="Service Impacted"
                Header5="Region"
                Header6="Severity"
                Header7="Duration"
                isLoading={loading}
                setisdrawerOpen={setisdrawerOpen}
                setDrawerType={setDrawerType}
                setDrawerChange={setDrawerChange}
              />
            </div>
          </McTabBar>
        </div>       
      </div>
      {<SubscribeDialog/>}
    </>
  );
}

export default Changes;
